exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".md-direction-bottom-right{width:30%!important}.mrgtop-2per{margin-top:1%}.mrgtop-5px{margin-top:0}.center{text-align:center}.heght-1px{height:1px}.b-form-input-container{margin:4px 0 12px!important}.md-button-color{background-color:#607d8d!important}.md-button-color-toggle{background-color:hsla(0,0%,60%,.4)!important}.activeClass{display:none}.error{color:red}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2c180095","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/component/masters/pagemoduleMaster.vue
// module id = 1470
// module chunks = 0